export default {"src":"/_next/static/media/DNUT.db5f5783.svg","height":18,"width":18};